// extracted by mini-css-extract-plugin
export var image = "tools-module--image--FzyJi";
export var title = "tools-module--title--QFgtM";
export var toolItem = "tools-module--toolItem--jNQOT";
export var toolsContainer = "tools-module--toolsContainer--ouEk2";